import { RaasAssessmentSourceTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';

export const ADMIN_STATE_PERSIST_KEY = 'nhe-remediation-admin-filters';

/**
 * Display labels for each PLP source type, used by the PLP Source Type column
 * and the filter dropdown labels.
 */
export const PLP_SOURCE_TYPE_LABELS: Partial<Record<RaasAssessmentSourceTypeDto, string>> = {
  [RaasAssessmentSourceTypeDto.HESI_USER_PERFORMANCE_EXAM__TESTTAKER_GUID]: 'HESI Remediation',
  [RaasAssessmentSourceTypeDto.SPARK_EOLS_ASSESSMENT_ID]: 'MedEd Remediation',
  // Legacy type kept for backward compatibility in non-prod
  [RaasAssessmentSourceTypeDto.HESI_USER_PERFORMANCE_EXAM]: 'HESI Remediation (Legacy)',
};

/**
 * Source type values an admin may filter by. Excludes the legacy type: it is
 * labelled for display, but is no longer written, so it is not offered as a filter.
 */
export const VALID_PLP_SOURCE_TYPE_FILTERS = [
  RaasAssessmentSourceTypeDto.HESI_USER_PERFORMANCE_EXAM__TESTTAKER_GUID,
  RaasAssessmentSourceTypeDto.SPARK_EOLS_ASSESSMENT_ID
];

/** Rendered in the PLP Source Type column when a source has no source type. */
export const UNKNOWN_PLP_SOURCE_TYPE_LABEL = '(unknown)';
